'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var delay = require('./delay.js');

const executeWithDelay = (callback, time) => _tslib.__awaiter(void 0, void 0, void 0, function* () {
    yield delay.delay(time);
    return callback();
});

exports.executeWithDelay = executeWithDelay;
//# sourceMappingURL=execute-with-delay.js.map
